import TemplateView from '../../../../../../TemplateView'

export default class YearSelector extends TemplateView {
    constructor({
        incrementYear = () => {},
        decrementYear = () => {}
    }) {
        super()

        this.actions = {
            incrementYear,
            decrementYear
        }

        this.state = {
            year: '',
            decrementDisabled: false,
            incrementDisabled: false,
            decrementHidden: false,
            incrementHidden: false,
        }

        this.onStatePropertyChanged('year', (year) => {
            this.$year.text(year)
        })

        this.onStatePropertyChanged('decrementDisabled', (disabled) => {
            this.$decrementButton.toggleClass('disabled', disabled)
        })

        this.onStatePropertyChanged('incrementDisabled', (disabled) => {
            this.$incrementButton.toggleClass('disabled', disabled)
        })

        this.onStatePropertyChanged('decrementHidden', (hidden) => {
            this.$decrementButton.toggleClass('invisible', hidden)
        })

        this.onStatePropertyChanged('incrementHidden', (hidden) => {
            this.$incrementButton.toggleClass('invisible', hidden)
        })
    }

    templateHtml() {
        return '<div class="yearSelector">' +
               '   <div class="decrementButton"/>' +
               '   <div class="year"/>' +
               '   <div class="incrementButton"/>' +
               '</div>'
    }

    afterRender() {
        this.$decrementButton = this.find('.decrementButton')
        this.$incrementButton = this.find('.incrementButton')
        this.$decrementButton.click(() => {
            if (!this.state.decrementDisabled)
                this.actions.decrementYear()
        })
        this.$incrementButton.click(() => {
            if (!this.state.incrementDisabled)
                this.actions.incrementYear()
        })

        this.$year = this.find('.year')
    }
}



// WEBPACK FOOTER //
// ./web/js/administration/workSchedule/components/panels/holidayList/components/YearSelector.js